import { render, staticRenderFns } from "./OptimizationAgent.vue?vue&type=template&id=707b0610&scoped=true"
import script from "./OptimizationAgent.vue?vue&type=script&lang=js"
export * from "./OptimizationAgent.vue?vue&type=script&lang=js"
import style0 from "./OptimizationAgent.vue?vue&type=style&index=0&id=707b0610&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../Library/WebServer/Documents/LSA-New-V2/frontend-diy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "707b0610",
  null
  
)

export default component.exports